import httpClient from "@config/httpClient";
import handleHttpClientErrors from "@utils/handleHttpClientErrors";

interface NewDeviceRegisterProps {
  userId: string;
  deviceRequestId: string;
  emailCode: string;
};

const updateDeviceRegisterCode = async (userData: NewDeviceRegisterProps) => {

  try {

    const response = await httpClient('/users/update_device_register', {
      method: 'PUT',
      data: userData
    });

    const data = response.data;

    return { error: false, data };

  } catch (error: any) {
    const { messages, status } = handleHttpClientErrors(error);
    return { error: true, messages, status };
  }

};

export default updateDeviceRegisterCode;